exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-split[data-v-4e872b67]{height:100%;border:1px solid #dcdee2}.demo-split-pane[data-v-4e872b67]{padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4e872b67","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationPlan/pdPatientEducationPlanStep.vue
// module id = Hlw/
// module chunks = 0